import { FETCH_TAG_SETS, CREATE_PORTAL_TAG } from '../actions/types'

export default (state = {}, action) => {
  // Changed initial state to {} instead of []
  switch (action.type) {
    case FETCH_TAG_SETS:
      return { ...state, [action.id]: action.payload }
    case CREATE_PORTAL_TAG:
      // Handle the case where state[action.id] might be undefined
      return {
        ...state,
        [action.id]: Array.isArray(state[action.id]) ? [...state[action.id], action.payload] : [action.payload]
      }
    default:
      return state
  }
}
